import FullCalendar from "@fullcalendar/react";
import esLocale from "@fullcalendar/core/locales/es";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

const CalendarComponent = ({ calendarRef, events, handleEventEdit }) => {
  return (
    <div className="calendar-app-main">
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
        headerToolbar={{
          left: "",
          center: "",
          right: "",
        }}
        locale={esLocale}
        initialView="dayGridMonth"
        events={events}
        eventTimeFormat={{
          hour: "2-digit",
          minute: "2-digit",
        }}
        // editable={true}
        selectable={true}
        allDaySlot={false}
        eventClick={handleEventEdit}
        dayMaxEvents={true}
        showNonCurrentDates={false}
      />
    </div>
  );
};

export default CalendarComponent;
